import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Input, FormGroup, UncontrolledTooltip
} from 'reactstrap'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import 'medium-draft/lib/index.css'
import {
  Editor, findLinkEntities, Link
  // createEditorState
} from 'medium-draft'
import { stateToHTML } from 'draft-js-export-html'
import { stateFromHTML } from 'draft-js-import-html'
import { EditorState, CompositeDecorator, ContentState } from 'draft-js'
import { FaPalette } from 'react-icons/fa'

const decorators = new CompositeDecorator([{
  strategy: findLinkEntities,
  component: Link
}])

const colorStyleMap = {
  RED: {
    color: 'red'
  },
  ORANGE: {
    color: 'orange'
  },
  GREEN: {
    color: 'green'
  },
  BLUE: {
    color: 'blue'
  },
  HIGHLIGHT: {
    backgroundColor: 'yellow'
  },
  hyperlink: {
    color: 'blue',
    backgroundColor: 'blue'
  }

}

const options = {
  inlineStyles: {
    // Override default element (`strong`).
    BOLD: { element: 'b' }
  }
}

// const fromOptions = {
//   customInlineFn: (element, { Style, Entity }) => {
//     if (element.style.color) { return Style(element.style.color.toUpperCase()) }
//     if (element.style.backgroundColor) { return Style('HIGHLIGHT') }
//   }
// }

class RichField extends Component {
  constructor (props) {
    super(props)
    const htmlString = props.defaultValue ? props.defaultValue : ''
    this.change = props.defaultOnChange ? props.defaultOnChange : null
    let contentState = stateFromHTML(htmlString)
    this.state = {
      editorState: EditorState.createWithContent(contentState, decorators), // for empty content
      html: htmlString
    }
    this.getRef = this.getRef.bind(this)
    this.clear = this.clear.bind(this)

    this.blockButtons = [{
      label: 'UL',
      style: 'unordered-list-item',
      icon: 'list-ul',
      description: 'Unordered List'
    },
    {
      label: 'H',
      style: 'header-three',
      icon: 'header',
      description: 'Heading'
    }]

    this.inlineButtons = [{
      label: 'B',
      style: 'BOLD',
      icon: 'bold',
      description: 'Bold'
    }, {
      label: 'I',
      style: 'ITALIC',
      icon: 'italic',
      description: 'Italic'
    }, {
      label: 'U',
      style: 'UNDERLINE',
      icon: 'underline',
      description: 'Underline'
    }, {
      label: 'S',
      style: 'STRIKETHROUGH',
      icon: 'strikethrough',
      description: 'Strikethrough'
    },
    { label: '#',
      style: 'hyperlink',
      icon: 'link',
      description: 'Add a link'
    }
    ]
    this.onChange = (editorState) => {
      this.setState({ editorState })
      let html = stateToHTML(this.state.editorState.getCurrentContent(), options)
      this.setState({ html })
      if (this.change) {
        this.change(html)
      }
    }

    this.refsEditor = React.createRef()
    this.clear = this.clear.bind(this)
  }

  componentDidUpdate (prevProps) {
    // clear rich field
    if ((prevProps.admin.admin.clearRichField !== this.props.admin.admin.clearRichField) && this.props.admin.admin.clearRichField === true) {
      this.clear()
      this.props.clearRichFieldDone()
      return
    }
    if ((prevProps.admin.admin.templateValue !== this.props.admin.admin.templateValue) && this.props.admin.admin.templateValue !== null) {
      let html = stateToHTML(this.state.editorState.getCurrentContent())
      let contentState
      let newHtml
      if (html === '<p><br></p>') {
        newHtml = '<div>' + this.props.admin.admin.templateValue + '</div>'
      } else {
        newHtml = '<div>' + html + '</div><div>' + this.props.admin.admin.templateValue + '</div>'
      }
      /* eslint-disable */
      contentState = stateFromHTML(newHtml)
      this.setState({ editorState: EditorState.createWithContent(contentState, decorators) })
      /* eslint-enable */
      if (this.change) {
        this.change(newHtml)
      }
    }
  }

  getRef (ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref)
    }
    this.ref = ref
  }

  clear () {
    const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''))
    this.setState({ editorState })
  }

  render () {
    const { editorState } = this.state
    let { innerRef } = this.props
    return (
      <FormGroup>
        <FaPalette id='editorHelp' tabIndex='-1' className='editorIcon' />
        <UncontrolledTooltip placement='top' target='editorHelp'>
            This is a rich text field. Select text you would like style or use common keyboard commands.
        </UncontrolledTooltip>
        <Editor
          customStyleMap={colorStyleMap}
          sideButtons={[]}
          ref={this.refsEditor}
          placeholder={this.props.placeholder || 'Enter value'}
          editorState={editorState}
          onChange={this.onChange}
          inlineButtons={this.inlineButtons}
          blockButtons={this.blockButtons}
        />

        <Input type='hidden' name={this.props.name} innerRef={innerRef} id={this.props.name} value={this.state.html} required />
        <div className='invalid-feedback' />
      </FormGroup>
    )
  }
}

RichField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  defaultOnChange: PropTypes.func,
  innerRef: PropTypes.object,
  clearRichFieldDone: PropTypes.func,
  admin: PropTypes.object
}

const mapStateToProps = (admin) => ({
  admin
})

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    clearRichFieldDone: () => ({ type: '/admin/CLEAR_RICH_FIELD_SUCCESS' })
  },
  dispatch
)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(RichField))



// WEBPACK FOOTER //
// ./src/containers/RichField.jsx